import React from 'react';
import { Challenge } from '../domain/types';
import { getItemEmoji } from '../data/challenges';
import './MagicCounter.css';

interface MagicCounterProps {
  challenge: Challenge;
  showHint?: boolean;
  reducedMotion?: boolean;
}

const MagicCounter: React.FC<MagicCounterProps> = ({ 
  challenge, 
  showHint = false,
  reducedMotion = false 
}) => {
  const { leftCount, rightCount, item } = challenge;
  const emoji = getItemEmoji(item);

  const renderItemGroup = (count: number, side: 'left' | 'right') => {
    const items = Array.from({ length: count }, (_, index) => (
      <div
        key={index}
        className={`magic-item ${side} ${showHint ? 'highlight' : ''}`}
        style={{
          animationDelay: showHint ? `${index * 0.3}s` : '0s'
        }}
      >
        {emoji}
      </div>
    ));

    return (
      <div className={`item-group ${side}-group`}>
        {items}
      </div>
    );
  };

  return (
    <div className="magic-counter">
      <div className="counter-container">
        {renderItemGroup(leftCount, 'left')}
        
        <div className="plus-sign">
          +
        </div>
        
        {renderItemGroup(rightCount, 'right')}
      </div>
      
      {showHint && (
        <div className="hint-text">
          Contemos juntas: 1… 2… 3… ¡Ahora elige el total!
        </div>
      )}
    </div>
  );
};

export default MagicCounter;
